export default "__VITE_ASSET__1N1sK1sL__"